// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2RmJZ","unreadBadge":"styles_unreadBadge__x-yIY","modalContent":"styles_modalContent__3aLsT","modal":"styles_modal__2r8pB"};